// The phrase-derived root key: BIP-39 seed, then SLIP-0010 Ed25519 hardened
// derivation along m/0'/0', the path the Build spec gives for Passport's
// existing derivation, so the same phrase gives the same #root in both.
import { hmac } from "@noble/hashes/hmac";
import { sha512 } from "@noble/hashes/sha512";
import { generateMnemonic, mnemonicToSeedSync, validateMnemonic } from "@scure/bip39";
import { wordlist } from "@scure/bip39/wordlists/english";
import { concat, utf8 } from "../crypto/encoding";

export const ROOT_PATH = [0, 0];   // m/0'/0'

export const newPhrase = (): string => generateMnemonic(wordlist, 128);
export const isPhrase = (p: string): boolean => validateMnemonic(p.trim().toLowerCase().replace(/\s+/g, " "), wordlist);

export function slip10Ed25519(seed: Uint8Array, path: number[]): Uint8Array {
  let I = hmac(sha512, utf8("ed25519 seed"), seed);
  let key = I.slice(0, 32), chain = I.slice(32);
  for (const index of path) {
    const i = (index | 0x80000000) >>> 0;
    const data = concat(new Uint8Array([0]), key, new Uint8Array([i >>> 24, (i >>> 16) & 255, (i >>> 8) & 255, i & 255]));
    I = hmac(sha512, chain, data);
    key = I.slice(0, 32); chain = I.slice(32);
  }
  return key;
}

export function rootSeedFromPhrase(phrase: string): Uint8Array {
  const norm = phrase.trim().toLowerCase().replace(/\s+/g, " ");
  if (!validateMnemonic(norm, wordlist)) throw new Error("not a valid 12-word recovery phrase");
  return slip10Ed25519(mnemonicToSeedSync(norm), ROOT_PATH);
}
